import { sortMenuButtonItems } from '@openx/utils/lib/tableHelpers.ts';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import type { CreativeRow } from '../types.ts';
import { useDeleteCreative } from './useDeleteCreative.tsx';

export const useRowActions = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { openDeleteModal, isLoading: deleteLoading } = useDeleteCreative();

  return useMemo(
    () =>
      sortMenuButtonItems<CreativeRow>({
        DETAILS: {
          'data-test': 'details-creative',
          label: t('Details'),
          onClick: creative => navigate(`/aqua/creatives/${creative.id}`),
        },
        EDIT: {
          'data-test': 'edit-creative',
          label: t('Edit'),
          onClick: creative => navigate(`/aqua/creatives/${creative.id}/edit`),
        },
        DELETE: {
          danger: true,
          'data-test': 'delete-creative',
          label: t('Delete'),
          loading: deleteLoading,
          onClick: creative => openDeleteModal({ creative }),
        },
      }),
    [navigate, t, deleteLoading, openDeleteModal]
  );
};
